import type {SharedBulkActionsItemPickerProps} from '@github-ui/item-picker-base/ItemPicker'
import type {IssueTypePickerProps} from '@github-ui/item-picker-issue-type-tsq'
import {
  BulkIssueIssueTypePicker as BulkIssueIssueTypePickerTsq,
  type BulkIssueIssueTypePickerProps as BulkIssueIssueTypePickerTsqProps,
} from '@github-ui/item-picker-issue-type-tsq/BulkIssueIssueTypePicker'
import {useCallback} from 'react'
import {useRelayEnvironment} from 'react-relay'

import {addIssueTypeToStore, updateIssueIssueTypeById} from './relay-issue-type-interop'

type BulkIssueIssueTypePickerProps = Omit<IssueTypePickerProps, 'onSelectionChange'> & SharedBulkActionsItemPickerProps

export function BulkIssueIssueTypePickerTsqWithRelayWrapper(props: BulkIssueIssueTypePickerProps) {
  const environment = useRelayEnvironment()
  const onMutate: BulkIssueIssueTypePickerTsqProps['onMutate'] = useCallback(
    input => {
      environment.commitUpdate(store => {
        const {ids, ...updateArgs} = input
        const issueTypeId = 'issueTypeId' in updateArgs ? updateArgs.issueTypeId : undefined

        // Add the issue type to the store for optimistic updates if provided
        if (issueTypeId && updateArgs.issueType) {
          addIssueTypeToStore(store, issueTypeId, updateArgs.issueType)
        }

        updateIssueIssueTypeById(store, ids, issueTypeId)
      })
    },
    [environment],
  )
  return <BulkIssueIssueTypePickerTsq {...props} onMutate={onMutate} />
}

// Re-export for backward compatibility
export {BulkIssueIssueTypePickerTsqWithRelayWrapper as BulkIssueIssueTypePicker}

try{ BulkIssueIssueTypePickerTsqWithRelayWrapper.displayName ||= 'BulkIssueIssueTypePickerTsqWithRelayWrapper' } catch {}